import { numberOr } from "../checkout/money";

export const EMPTY_PAGE = {
  items: [],
  total: 0,
  totalPages: 0,
  page: 0,
  pageSize: 0,
  isLast: true,
};

const listFrom = (dto, ...keys) => {
  if (Array.isArray(dto)) return dto;

  const found = [...keys, "content", "data"].find((key) => Array.isArray(dto?.[key]));

  return found ? dto[found] : [];
};

export const pickList = (dto, ...keys) => listFrom(dto, ...keys);

export const normalizeSpringPage = (dto) => {
  if (!dto) return EMPTY_PAGE;

  const items = listFrom(dto, "content");
  const total = numberOr(dto?.totalElements, items.length);
  const totalPages = numberOr(dto?.totalPages, items.length ? 1 : 0);
  const page = numberOr(dto?.number, 0);

  return {
    items,
    total,
    totalPages,
    page,
    pageSize: numberOr(dto?.size, items.length),
    isLast: dto?.last === undefined ? page + 1 >= totalPages : Boolean(dto.last),
  };
};

export const normalizeSharedPage = (dto) => {
  if (!dto) return EMPTY_PAGE;

  if (!Array.isArray(dto) && dto?.data === undefined && Array.isArray(dto?.content)) {
    return normalizeSpringPage(dto);
  }

  const items = listFrom(dto, "data");
  const total = numberOr(dto?.totalElements, items.length);
  const totalPages = numberOr(dto?.totalPages, items.length ? 1 : 0);
  const page = numberOr(dto?.currentPage, 1);

  return {
    items,
    total,
    totalPages,
    page,
    pageSize: numberOr(dto?.pageSize, items.length),
    isLast: totalPages ? page >= totalPages : true,
  };
};

export const sharedPageParams = ({ page = 1, pageSize = 10 } = {}) => ({
  page,
  page_size: pageSize,
});

export const sapphirePageParams = ({ page = 0, size = 20, sort } = {}) => ({
  page,
  size,
  ...(sort ? { sort } : {}),
});
